import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import './Withdrawal.css'; // Custom CSS for additional styling

const Withdrawal = () => {
    const [withdrawals, setWithdrawals] = useState([]);
    const [amount, setAmount] = useState(1000);
    const [balance, setBalance] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        fetchWithdrawalData();
    }, []);

    const fetchWithdrawalData = async () => {
        try {
            const userId = localStorage.getItem('userid');
            const [withdrawalsRes, balanceRes] = await Promise.all([
                axios.get(`https://wealthmcx.com/Rest5/withdrawals_api/${userId}`),
                axios.get(`https://wealthmcx.com/Rest5/wallet_api/${userId}`)
            ]);
            setWithdrawals(withdrawalsRes.data);
            setBalance(balanceRes.data.wallet || 0);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleCancelRequest = async (withdrawalId) => {
        if (window.confirm("Are you sure you want to cancel this withdrawal request?")) {
            try {
                await axios.get(`https://wealthmcx.com/Rest5/cancel_withdrawal_api/${withdrawalId}`);
                alert("Withdrawal request cancelled successfully");
                fetchWithdrawalData();
            } catch (error) {
                console.error("Error cancelling withdrawal:", error);
                alert("Failed to cancel withdrawal request");
            }
        }
    };

    const handleSubmit = async () => {
        if (amount < 1000) {
            alert("Minimum withdrawal amount is ₹1000");
            return;
        }
        if (amount > balance) {
            alert("Insufficient balance for withdrawal");
            return;
        }

        setIsSubmitting(true);
       try {
    const formData = new FormData();
    formData.append('withdrawAmt', amount);
    
    const response = await axios.post(
        `https://wealthmcx.com/Rest5/web_withdraw_submit_api/${localStorage.getItem('userid')}`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
    alert(response.data.msg);
    fetchWithdrawalData();
    setAmount(1000);
} catch (error) {
    console.error("Withdrawal error:", error);
    alert("Could not process withdrawal request");
} finally {
    setIsSubmitting(false);
}

    };

    const getStatusBadge = (status) => {
        const statusClasses = {
            'Pending': 'pending',
            'Approved': 'approved',
            'Rejected': 'rejected',
            'Cancelled': 'cancelled'
        };
        return <span className={`status-badge ${statusClasses[status] || ''}`}>{status}</span>;
    };

    return (
        <div className="withdrawal-page">
            <Helmet>
                <title>Withdraw Funds | MCX Trading</title>
            </Helmet>

            {/* Header */}
            <header className="withdrawal-header">
                <Link to="/dashboard" className="back-button">
                    <i className="fa fa-arrow-left"></i>
                </Link>
                <h1>Withdraw Funds</h1>
                <div className="header-spacer"></div>
            </header>

            <main className="withdrawal-content">
                {/* Balance Info */}
                <div className="balance-card">
                    <div className="balance-info">
                        <span>Available Balance</span>
                        <h2>₹{balance.toLocaleString('en-IN')}</h2>
                    </div>
                </div>

                {/* Withdrawal Form */}
                <div className="withdrawal-form">
                    <h3>Withdrawal Amount</h3>
                    <div className="amount-input">
                        <span className="currency">₹</span>
                        <input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(Number(e.target.value))}
                            placeholder="Enter amount"
                            min="1000"
                            step="100"
                        />
                    </div>
                    
                    <div className="amount-presets">
                        <button onClick={() => setAmount(1000)}>₹1,000</button>
                        <button onClick={() => setAmount(5000)}>₹5,000</button>
                        <button onClick={() => setAmount(10000)}>₹10,000</button>
                    </div>
                    
                    <button 
                        className="submit-btn"
                        onClick={handleSubmit}
                        disabled={isSubmitting || amount < 1000}
                    >
                        {isSubmitting ? (
                            <>
                                <i className="fa fa-spinner fa-spin"></i> Processing...
                            </>
                        ) : (
                            "REQUEST WITHDRAWAL"
                        )}
                    </button>
                </div>

                {/* Withdrawal History */}
                <div className="withdrawal-history">
                    <h3>Withdrawal History</h3>
                    
                    {withdrawals.length === 0 ? (
                        <div className="empty-state">
                            <i className="fa fa-history"></i>
                            <p>No withdrawal history found</p>
                        </div>
                    ) : (
                        <div className="history-list">
                            {withdrawals.map((withdrawal) => (
                                <div className="history-item" key={withdrawal.wid}>
                                    <div className="item-details">
                                        <div className="amount">₹{withdrawal.wamt}</div>
                                        <div className="date">{withdrawal.req_date}</div>
                                        {withdrawal.remarks && (
                                            <div className="remarks">{withdrawal.remarks}</div>
                                        )}
                                    </div>
                                    <div className="item-actions">
                                        {getStatusBadge(withdrawal.req_status)}
                                        {withdrawal.req_status !== 'Approved' && (
                                            <button 
                                                className="cancel-btn"
                                                onClick={() => handleCancelRequest(withdrawal.wid)}
                                            >
                                                Cancel
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default Withdrawal;